import { type FC } from 'react';

import { Content, SearchJob } from 'components';

export const JobSearchPage: FC = () => {
  return (
    <Content dataTestId="job-search-page" hasContainer>
      <title>Job Search</title>
      <SearchJob />
    </Content>
  );
};
